import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";

import "./Footer.css";
import Logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-about">
          <img src={Logo} alt="SG Office Logo" className="footer-logo" />

          <p>
            Trusted office supply partner since 2010, providing quality
            stationery, educational products, and business essentials across UAE.
          </p>

          <div className="footer-socials">
            <a href="https://www.instagram.com/sgofficesupplies.2022/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>

            <a href="https://www.linkedin.com/company/sg-office-supplies-limited/?originalSubdomain=ae" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>

            <a href="https://www.facebook.com/Stationeryeproduct/" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/sign-graphics">Sign & Graphics</Link>
          <Link to="/catalogue">Catalogue</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-links">
          <h3>Categories</h3>
          <Link to="/products?category=files-folders">Files & Folders</Link>
          <Link to="/products?category=writing-instruments">Writing Instruments</Link>
          <Link to="/products?category=office-equipment">Office Equipment</Link>
          <Link to="/products?category=art-craft">Arts & Crafts</Link>
        </div>

        <div className="footer-contact">
          <h3>Contact Info</h3>

          <p>
            <FaPhoneAlt />
            <a href="tel:0509348007">0509348007</a>
          </p>

          <p>
            <FaEnvelope />
            <a href="mailto:sales@sgoffice.me">sales@sgoffice.me</a>
          </p>

          <p>
            <FaMapMarkerAlt />
            Warehouse 36, 4B St, next to Easy Truck Warehouse, Al Quoz, Dubai
          </p>

          <div className="footer-buttons">
            <a
              href="https://wa.me/971509348007?text=Hi%2C%20I%20would%20like%20to%20make%20an%20enquiry."
              target="_blank"
              rel="noreferrer"
              className="footer-whatsapp"
            >
              <FaWhatsapp /> WhatsApp
            </a>

            <a
              href="https://www.google.com/maps/place/SG+Office+Supplies+LLC/@25.1395448,55.2190809,17z/data=!4m6!3m5!1s0x3e5f6b27ed053e07:0xadbed7d539b0419b!8m2!3d25.13954!4d55.2216558!16s%2Fg%2F11s7s8gsxr?entry=ttu"
              target="_blank"
              rel="noreferrer"
              className="footer-map"
            >
              View Map
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 SG Office Supplies LLC. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;